import { render, staticRenderFns } from "./CommentTreePrevious.vue?vue&type=template&id=347082eb&scoped=true"
import script from "./CommentTreePrevious.vue?vue&type=script&lang=js"
export * from "./CommentTreePrevious.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "347082eb",
  null
  
)

export default component.exports